/*
 * Tailwind only builds the classes it can read in the source, so every
 * breakpoint is written out. Below it, the full label is for screen readers
 * only and the short one shows. Index 0 is 6rem, one rem per step.
 */
const BREAKPOINTS = [
  { label: '@max-[6rem]/pill:sr-only', short: '@max-[6rem]/pill:block' },
  { label: '@max-[7rem]/pill:sr-only', short: '@max-[7rem]/pill:block' },
  { label: '@max-[8rem]/pill:sr-only', short: '@max-[8rem]/pill:block' },
  { label: '@max-[9rem]/pill:sr-only', short: '@max-[9rem]/pill:block' },
  { label: '@max-[10rem]/pill:sr-only', short: '@max-[10rem]/pill:block' },
  { label: '@max-[11rem]/pill:sr-only', short: '@max-[11rem]/pill:block' },
  { label: '@max-[12rem]/pill:sr-only', short: '@max-[12rem]/pill:block' },
  { label: '@max-[13rem]/pill:sr-only', short: '@max-[13rem]/pill:block' },
  { label: '@max-[14rem]/pill:sr-only', short: '@max-[14rem]/pill:block' },
  { label: '@max-[15rem]/pill:sr-only', short: '@max-[15rem]/pill:block' },
  { label: '@max-[16rem]/pill:sr-only', short: '@max-[16rem]/pill:block' },
] as const;

const SMALLEST_REM = 6;

/* Measured in the pill's bold 2xs type: "Opstarttraject · stap 2?" sets 119px for 24 characters. */
const REM_PER_CHARACTER = 0.3125;

export type PillLabelBreakpoint = (typeof BREAKPOINTS)[number];

/**
 * The container width below which a pill trades its label for the short form:
 * the width the label is expected to need, rounded up to a whole rem. Past the
 * last step the full label stays and ends in "…".
 */
export function pillLabelBreakpoint(
  label: string,
  chromeRem: number,
): PillLabelBreakpoint {
  const neededRem = Math.ceil(label.length * REM_PER_CHARACTER + chromeRem);
  const step = Math.min(Math.max(neededRem - SMALLEST_REM, 0), BREAKPOINTS.length - 1);
  return BREAKPOINTS[step];
}
